import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

class EmailField extends React.Component {
  render() {
    const { input, meta, disabled } = this.props;
    const { touched, error } = meta;
    return (
      <div
        className={`has-feedback ${
          touched ? (error ? 'has-error' : 'has-success') : ''
        }`}
      >
        <input
          {...input}
          type="text"
          className="form-control"
          placeholder="Email"
          disabled={disabled}
        />
        {this._icon()}
      </div>
    );
  }

  _icon = () => {
    const {
      input: { value },
      meta: { error, touched },
    } = this.props;

    if (touched && error) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip">{error}</Tooltip>}
        >
          <span
            className={`form-control-feedback glyphicon glyphicon-remove`}
            style={{ 'pointer-events': 'auto', cursor: 'pointer' }}
          />
        </OverlayTrigger>
      );
    }
    if (touched) {
      return <span />;
    }
    if (!touched && value) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip">Waiting For Verification</Tooltip>}
        >
          <span
            className={`form-control-feedback glyphicon glyphicon-time`}
            style={{
              'pointer-events': 'auto',
              cursor: 'pointer',
              color: '#e3a300',
            }}
          />
        </OverlayTrigger>
      );
    }
  };
}

export default EmailField;
